import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
import "./apps";
import "./components/global";
import "./components/parts/data-collapse";
import "./components/parts/page-nav";
import "./components/parts/links-select";
import "./components/parts/clickable-cards";